var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisionaiNav2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.015,
    height: 24.004,
    viewBox: "0 0 23.015 24.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_106157",
    "data-name": "Path 106157",
    d: "M20.507,3.023a1,1,0,0,0-.71.283l-3.5,3.528a1,1,0,0,0,1.421,1.41l1.791-1.8V17.547a1,1,0,1,0,2,0V6.441l1.791,1.8a1,1,0,0,0,1.421-1.41l-3.5-3.528A1,1,0,0,0,20.507,3.023ZM12,10.016a3,3,0,0,0-3,3V24.025a3,3,0,0,0,3,3H29.013a3,3,0,0,0,3-3V13.018a3,3,0,0,0-3-3h-6v2h6a1,1,0,0,1,1,1V24.025a1,1,0,0,1-1,1H12a1,1,0,0,1-1-1V13.018a1,1,0,0,1,1-1h6v-2Z",
    transform: "translate(-9 -3.023)",
    fill: "#080e15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionaiNav2);
export default __webpack_public_path__ + "static/media/visionai_nav2.b29936de3d7eb7db8c88727099725fc3.svg";
export { ForwardRef as ReactComponent };